module.exports = __webpack_public_path__ + "img/gold_coin.3d0a0d27.png";